import { computed } from 'vue';
import { appModules } from '@/config/modulesConfig';
import { useModuleStore } from '@/stores/moduleStore';

export function useAppModules() {
  const moduleStore = useModuleStore();

  // El módulo activo ya no es un ref local: vive en moduleStore (A2).
  const currentModule = computed(() => appModules[moduleStore.activeModuleId.value] || appModules.core);

  // Obtener solo el menú del módulo actual
  const currentMenu = computed(() => currentModule.value.menu);

  return {
    modulesList: appModules, // Para el selector
    currentModule,
    currentMenu,
    switchModule: moduleStore.switchModule,
  };
}